import React from 'react';
import { Drawer, Box, useTheme } from '@mui/material'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface OwnProps {
  readonly children?: React.ReactNode;
  readonly isDrawerOpen: boolean;
  readonly handleToggle: () => void;
}

type Props = OwnProps;

// const useStyles = makeStyles((theme: Theme) => ({
//   mobileDrawer: {
//     width: '100%',
//     height: 'calc(100% - 0px)',
//     bottom: 0,
//     top: '92px !important',
//     [theme.breakpoints.up('md')]: {
//       display: 'none',
//     },
//     '&::-webkit-scrollbar': {
//       height: '0.5rem',
//       width: '0.5rem',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       backgroundColor: theme.palette.grey[400],
//       borderRadius: '0.5rem',
//     },
//   },
// }));

const LegsDrawer = (props: Props) => {
  const { children, isDrawerOpen, handleToggle } = props;
  const theme = useTheme();

  return (
    <>
      <Drawer
        anchor="left"
        PaperProps={{
          sx: {
            width: '100%',
            // height: 'calc(100% - 0px)',
            height: '100%',
            // bottom: 0,
            // top: '92px !important',
            [theme.breakpoints.up('md')]: {
              display: 'none',
            },
            '&::-webkit-scrollbar': {
              height: '0.5rem',
              width: '0.5rem',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme.palette.grey[400],
              borderRadius: '0.5rem',
            },
          }
        }}
        onClose={handleToggle}
        open={isDrawerOpen}
        variant="temporary"
      >
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflowX: 'hidden',
            padding: '0px',
          }}
          id='legs-drawer-mobile'
        >
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <IconButton size="small" onClick={handleToggle}>
              <CloseIcon sx={{ color: 'white'}} />
            </IconButton>
          </Box>
          {children}
        </Box>
      </Drawer>
    </>
  );
};

export default LegsDrawer;
